import { round } from 'lodash';

/*
  Format an integer to string, with numDecimals rounding and pad with
  zero's accordingly.
*/
export default function formatFloat(value, numDecimals = 1) {
  const roundedValue = round(value, numDecimals);
  const integer = Math.floor(roundedValue);

  // Round needs to be here, otherwise BIG ranges of decimals can happen. Not sure why.
  const decimals = round(roundedValue - integer, numDecimals) * 10 ** numDecimals;
  const decimalsStr = `${decimals}`.padEnd(numDecimals, '0');

  return `${integer}.${decimalsStr}`;
}



// WEBPACK FOOTER //
// ./src/helpers/formatFloat.js